import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { List, ListItem, ListItemButton, ListItemText, SxProps } from "@mui/material";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts, themeSettings } from "../../../../configuration/themeSettings";


export const StyledList = styled(List, {
    label: "AppBasketMenu-dotMenuList",
})(({ theme: Theme }) => ({
    paddingTop: 0, paddingBottom: 0
}));

export const StyledListItemButton = styled(ListItemButton, {
    label: "AppBasketMenu-dotMenuListItemButton",
})(({ theme: Theme }) => ({
    borderBottom: "1px solid " + StyleguideSavioColors.lightGrey,
    paddingLeft: 13,
    paddingRight: 13,

    "&:not(.selected):hover": {
        backgroundColor: "#fff",
        
        

        "*": { textDecoration: 'underline', color: StyleguideSavioColors.blue,},
        "&:before": {
            display: 'block',
            content: "''",
            width: 3,
            height: '100%',
            backgroundColor: StyleguideSavioColors.blue,
            left: 0,
            position: 'absolute',
            zIndex: 1,

        },

    }

}));

export const StyledListItemText = styled(ListItemText, {
    label: "AppBasketMenu-dotMenuListItemText",
})(({ theme: Theme }) => ({
    color: StyleguideSavioColors.text.black,

    ".MuiTypography-root": {
        fontWeight: StyleguideSavioFonts.medium,
        fontSize: 12,
    }
}));

;